export default function Hero() {
  const whatsappNumber = '+96871989006';
  const whatsappMessage = 'Hello Cleaning Bees, I would like to inquire about your cleaning services.';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const quickServices = [
    { name: 'House Cleaning', icon: 'ri-home-smile-line', link: '#services' },
    { name: 'Maid Services', icon: 'ri-user-heart-line', link: '#services' },
    { name: 'Office Cleaning', icon: 'ri-briefcase-line', link: '#services' },
    { name: 'Deep Cleaning', icon: 'ri-brush-line', link: '#services' },
    { name: 'Sofa & Carpet', icon: 'ri-sofa-line', link: '#services' },
    { name: 'Pool Cleaning', icon: 'ri-water-flash-line', link: '#services' },
    { name: 'Marble Polishing', icon: 'ri-contrast-drop-line', link: '#services' },
    { name: 'Pest Control', icon: 'ri-bug-line', link: '#services' }
  ];

  return (
    <div id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-yellow-50 via-white to-yellow-50 pt-28">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/d60a61831ab01c1408561a160b55b2ec.jpg')] bg-cover bg-center opacity-15"></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-yellow-400/5 via-transparent to-white/80"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="space-y-8">
          {/* Bee Symbol */}
          <div className="flex justify-center mb-6">
            <div className="w-24 h-24 bg-yellow-400 rounded-full flex items-center justify-center shadow-2xl animate-bounce">
              <i className="ri-bug-line text-5xl text-black"></i>
            </div>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            <span className="text-yellow-500">Professional Cleaning Company Oman</span><br />
            House Cleaning &amp; Office Cleaning Services Muscat
          </h1>
          
          <p className="text-xl sm:text-2xl text-gray-600 max-w-3xl mx-auto">
            <strong>Leading cleaning services Oman</strong> – Affordable house cleaning, deep cleaning, villa cleaning &amp; commercial cleaning across Muscat, Seeb, Barka, Sohar
          </p>

          <p className="text-lg text-gray-500 max-w-2xl mx-auto">
            Trusted <strong>cleaning company in Oman</strong> serving residential and commercial clients with professional cleaning services. Expert team, eco-friendly products, guaranteed satisfaction.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-6">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center space-x-3 bg-green-500 text-white px-8 py-4 rounded-lg hover:bg-green-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              <span className="font-semibold text-lg">WhatsApp Now</span>
            </a>
            
            <a
              href={`tel:${whatsappNumber}`}
              className="flex items-center justify-center space-x-3 bg-yellow-500 text-black px-8 py-4 rounded-lg hover:bg-yellow-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 whitespace-nowrap cursor-pointer w-full sm:w-auto"
            >
              <i className="ri-phone-line text-2xl"></i>
              <span className="font-semibold text-lg">Call Now</span>
            </a>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto pt-12">
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-md border-2 border-yellow-200">
              <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-shield-check-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Trusted Cleaning Service Oman</h3>
              <p className="text-sm text-gray-600">Professional &amp; reliable cleaning experts across Oman</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-md border-2 border-yellow-200">
              <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-leaf-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Eco-Friendly Products</h3>
              <p className="text-sm text-gray-600">Safe cleaning products for your family in Oman</p>
            </div>
            
            <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-md border-2 border-yellow-200">
              <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <i className="ri-price-tag-3-line text-2xl text-yellow-600"></i>
              </div>
              <h3 className="font-semibold text-gray-900 mb-2">Affordable Cleaning Rates</h3>
              <p className="text-sm text-gray-600">Quality cleaning services at competitive prices</p>
            </div>
          </div>

          {/* Quick Services Highlight */}
          <div className="pt-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8">
              Our <span className="text-yellow-500">Popular Services</span>
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-4 max-w-6xl mx-auto">
              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-home-smile-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">House Cleaning</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-user-heart-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Maid Services</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-briefcase-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Office Cleaning</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-brush-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Deep Cleaning</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-sofa-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Sofa & Carpet</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-water-flash-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Pool Cleaning</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-contrast-drop-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Marble Polishing</p>
              </button>

              <button
                onClick={scrollToServices}
                className="group bg-white p-4 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer border-2 border-transparent hover:border-yellow-400"
              >
                <div className="w-14 h-14 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-yellow-400 transition-colors">
                  <i className="ri-bug-line text-2xl text-yellow-600 group-hover:text-black"></i>
                </div>
                <p className="text-sm font-semibold text-gray-900">Pest Control</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}